import * as React from 'react';
import {

    List,
    EditButton,
    Datagrid,
    TextField, DateField, BooleanField, ReferenceManyCount, Link, useRecordContext,
    Filter,
    TextInput,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { DeleteWithDialogAction } from "../../common/DeleteWithDialogAction";
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import banner_categories from '.';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const BannersLinkComponent = () => {
    const record = useRecordContext();
    return <Link
        to={`/banners?displayedFilters={}&filter=${encodeURIComponent(JSON.stringify({ categoryId: record.id }))}`}>
        Banners
        (
        {record ? record.bannerCount : 0}
        )
    </Link>
}
const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const BannerCategoriesList = () => {
    const { isDeletable, isWritable, isUpdatable } = useIsPermission("BANNERS");

    return (
        <div>
            <List
                filters={<ListFilter />}
                actions={<PermissionBasedActions isWritable={isWritable} />}
                queryOptions={{
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                }}
            >
                <Datagrid>
                    <TextField source="name" />
                    <FormattedDateTimeField source="createdAt" />
                    <BannersLinkComponent />
                    {isUpdatable &&
                        <EditButton />
                    }
                    {isDeletable &&
                        <ConfirmDeleteButton />
                    }
                </Datagrid>
            </List>
        </div>
    );
};
export default BannerCategoriesList;
